import moment from 'moment';

/**
 * Single source of truth for the Month view's rolling 8-week window math.
 *
 * The Month view is decoupled from calendar months: it always shows exactly
 * 8 weeks (56 days) starting at a Sunday "window start". Entry, the Today
 * button, and picker day-selection all center the window on a focus week
 * (2 weeks before the focus week becomes the top of the window); the header
 * label and the visible-date set derive from that same window start.
 */

export const MONTH_VIEW_WEEKS = 8;
export const MONTH_VIEW_WINDOW_DAYS = MONTH_VIEW_WEEKS * 7; // 56

/**
 * Sunday (YYYY-MM-DD) of the top week of the window when focusDate is the
 * focus week: 2 weeks before the focus week's start.
 */
export const getMonthViewWindowStart = (focusDate) => moment(focusDate)
  .startOf('week')
  .subtract(2, 'weeks')
  .format('YYYY-MM-DD');

/**
 * The 56 day-keys (YYYY-MM-DD) of the window, in order, starting at its top
 * Sunday.
 */
export const getMonthViewWindowDateKeys = (windowStart) => {
  const start = moment(windowStart, 'YYYY-MM-DD').startOf('week');
  const keys = [];
  for (let i = 0; i < MONTH_VIEW_WINDOW_DAYS; i += 1) {
    keys.push(start.clone().add(i, 'days').format('YYYY-MM-DD'));
  }
  return keys;
};

/**
 * Combined month(s)/year(s) and the first→last week numbers spanned by the
 * window, for the calendar subheader (e.g. "Jun - Aug", "2026", W23–W30).
 */
export const getMonthViewWindowLabel = (windowStart) => {
  const start = moment(windowStart, 'YYYY-MM-DD').startOf('week');
  const end = start.clone().add(MONTH_VIEW_WINDOW_DAYS - 1, 'days');
  const monthsLabel = start.month() === end.month()
    ? start.format('MMM')
    : `${start.format('MMM')} - ${end.format('MMM')}`;
  const yearLabel = start.year() === end.year()
    ? start.format('YYYY')
    : `${start.format('YYYY')} - ${end.format('YYYY')}`;
  return {
    monthsLabel, yearLabel, firstWeek: start.week(), lastWeek: end.week(),
  };
};
